import { ChangeDetectorRef, Component, inject, Injector, input } from '@angular/core';
import { ButtonSize, ButtonTypes } from '@shared/modules/ui/components/button/button.component';
import { tap } from 'rxjs/operators';
import { ListService } from '@shared/modules/list/services/list.service';
import { WindowHelper } from '@shared/helpers/window.helper';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'list-filters-btn-v2',
  templateUrl: './list-filters-btn-v2.component.html',
  styleUrls: ['./list-filters-btn-v2.component.scss']
})
export class ListFiltersButtonV2Component {
  readonly ButtonSize = ButtonSize;
  readonly ButtonTypes = ButtonTypes;
  readonly WindowHelper = WindowHelper;

  protected filters = input(undefined);
  protected readonly hasActiveFilters = input(false);

  protected readonly dialogRef = inject(MatDialog);
  private readonly changes = inject(ChangeDetectorRef);
  private readonly service = inject(ListService);
  private readonly injector = inject(Injector);
  private readonly activatedRoute = inject(ActivatedRoute);

  protected shouldShowActiveDot(): boolean {
    if (this.hasActiveFilters()) return true;

    const hasActiveQueryFilters = this.activatedRoute.snapshot.queryParamMap.keys.some((key) => {
      if (!key.startsWith('filters[')) return false;

      const value = this.activatedRoute.snapshot.queryParamMap.get(key);
      return value !== null && value !== undefined && value !== '' && value !== '0' && value !== 'false';
    });
    if (hasActiveQueryFilters) return true;

    const filtersForm = this.service.filtersForm;
    if (!filtersForm) return false;

    return Object.values(filtersForm.value || {}).some((value) => {
      if (Array.isArray(value)) return value.length > 0;
      return value !== null && value !== undefined && value !== '' && value !== false && Number(value) !== 0;
    });
  }

  openFilters() {
    if (!this.filters()) return;
    this.service.isFiltersOpened = true;
    const dialogInjector = Injector.create({
      providers: [{ provide: ListService, useValue: this.service }],
      parent: this.injector
    });
    const dialog = this.dialogRef.open(this.filters(), {
      disableClose: true,
      injector: dialogInjector
    });

    dialog.afterClosed().pipe(
      tap(() => {
        this.service.isFiltersOpened = false;
        this.changes.detectChanges();
      })
    );
  }
}
